import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const LANE_CLOSURE_SAFETY_SEGMENT_LAYER_ID = 'laneClosureSafetySegmentLayer';

const layerConfig = {
  title: 'Lane Closure Safety Segment Layer',
};

// Keep color order aligned to the UI palette screenshot, ignoring its labels.
const TYPE_OF_WORK_COLORS = {
  'Electrical Work': [103, 188, 199],
  'Highway Construction': [232, 195, 102],
  'Pavement Work': [234, 141, 99],
  'Guardrail Work': [199, 160, 224],
  'Utility Work': [124, 188, 87],
};

const OTHER_WORK_COLOR = [163, 163, 163];

const getTypeOfWorkColor = (feature) => {
  const typeOfWork = feature?.properties?.Type_Of_Work;
  return TYPE_OF_WORK_COLORS[typeOfWork] || OTHER_WORK_COLOR;
};

function LaneClosureSafetySegmentLayer() {
  const dispatch = useDispatch();
  const { laneClosureSafetySegmentLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, laneClosureSafetySegmentLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 7 :4;

  if (laneClosureSafetySegmentLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: LANE_CLOSURE_SAFETY_SEGMENT_LAYER_ID,
  
      stroked: false,
      filled: false,
      lineWidthUnits: 'pixels',
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      pickable: true,
      lineWidthScale: 1,
      visible: laneClosureSafetySegmentLayer.visible,
      opacity: laneClosureSafetySegmentLayer.opacity,

      getLineColor: getTypeOfWorkColor,
      coverage: 0.95,
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: LANE_CLOSURE_SAFETY_SEGMENT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['h3'],
            }),
          };
        }
      },
    });
  }
}

export default LaneClosureSafetySegmentLayer;
